import axios from "axios";
import config from "../constants/config";

export default {
    methods: {
        async GetATCCTrafficData ({ page }) {
            let query = `?page=${page}`;
            const res = await axios.get(
                `${config.BASE_URL}${config.API_ROUTES.ATCC.GET_TRAFFIC}${query}`
            );

            return res.data;
        },
        async GetATCCRecordByID (recordId) {
            const res = await axios.get(
                `${config.BASE_URL}${config.API_ROUTES.ATCC.GET_RECORD_BY_ID}${recordId}`
            );

            return res.data;
        },
        async GetAtccFiltersData () {
            const res = await axios.get(
                `${config.BASE_URL}${config.API_ROUTES.ATCC.GET_ATCC_FILTERS}`
            );

            return res.data;
        },
        async GetFilteredATCCRecords ({
            page,
            recordId,
            vehicleNumber,
            fromDate,
            toDate,
            vehicleClass,
            location,
            side,
            site
        }) {
            let query = `?page=${page}`;
            if (recordId) query += `&recordId=${recordId}`;
            if (vehicleNumber)
                query += `&vehicleNumber=${vehicleNumber}`;
            if (fromDate) query += `&fromDate=${fromDate}`;
            if (toDate) query += `&toDate=${toDate}`;
            if (vehicleClass) query += `&vehicleClass=${vehicleClass}`;
            if (location) query += `&location=${location}`;
            if (side) query += `&side=${side}`;
            if (site) query += `&site=${site}`;

            const res = await axios.get(
                `${config.BASE_URL}${config.API_ROUTES.ATCC.GET_FILTERED_TRAFFIC}${query}`
            );

            return res.data;
        },
    }
}